export const skillCategories = [
  {
    key: "data-analytics",
    title: "Data & Analytics",
    summary:
      "Transforming raw data into reusable assets through visualization, scripting, and statistical tooling.",
    items: [
      { name: "Tableau", note: "Experienced" },
      { name: "Google Looker Studio / Data Studio", note: "Proficient" },
      { name: "Microsoft Excel", note: "Highly experienced" },
      { name: "Google Sheets", note: "Experienced" },
      { name: "SQL", note: "Proficient" },
      {
        name: "Python",
        note: "Intermediate — applied for analytics and automation",
      },
      { name: "Jupyter & Google Colab", note: "Intermediate" },
      { name: "Power BI", note: "Familiar" },
      {
        name: "R",
        note: "Advanced — created scripts for ETL of public healthcare data",
      },
      { name: "RStudio", note: "Advanced" },
    ],
  },
  {
    key: "development-web-interfaces",
    title: "Development — Web & Interfaces",
    summary:
      "Frontend frameworks, app builders, and tooling used to deliver polished interfaces.",
    items: [
      { name: "HTML5 & CSS3", note: "Advanced" },
      { name: "JavaScript", note: "Advanced" },
      { name: "React", note: "Intermediate" },
      { name: "Next.js", note: "Intermediate" },
      {
        name: "AppSheet",
        note: "Experienced — delivers automation-ready business apps",
      },
      { name: "Firebase", note: "Intermediate" },
      { name: "Git & GitHub", note: "Moderate" },
      { name: "Markdown", note: "Experienced" },
      { name: "Visual Studio Code", note: "Primary IDE" },
      { name: "Postman", note: "API testing and contract validation" },
    ],
  },
  {
    key: "development-automation-platforms",
    title: "Development — Automation & Platforms",
    summary:
      "Automation-centric scripting, backend services, and deployment platforms.",
    items: [
      {
        name: "Google Apps Script & Webhooks",
        note: "Advanced — built webhook endpoints to receive, split, and distribute datasets",
      },
      {
        name: "Python",
        note: "Intermediate — automation assistants and data pipelines",
      },
      {
        name: "Selenium",
        note: "Intermediate — used to navigate and download Excel files automatically",
      },
      { name: "Bash / Shell", note: "Proficient" },
      {
        name: "PowerShell",
        note: "Proficient — used for secure execution and environment prep",
      },
      {
        name: "Batch scripting",
        note: "Proficient — used to orchestrate PowerShell execution and R sequences",
      },
      { name: "Node.js", note: "Intermediate" },
      { name: "MongoDB", note: "Intermediate" },
      { name: "Vercel", note: "Production deployments" },
      { name: "Heroku", note: "Legacy deployments" },
    ],
  },
  {
    key: "collaboration-productivity",
    title: "Collaboration & Productivity",
    summary: "Keeping projects aligned and stakeholders informed.",
    items: [
      {
        name: "Google Workspace (Docs, Drive, Slides, Forms)",
        note: "Experienced",
      },
      { name: "Notion", note: "Familiar" },
      { name: "Trello", note: "Familiar" },
      { name: "Asana", note: "Basic familiarity" },
      { name: "Miro", note: "Familiar" },
      { name: "LibreOffice / OpenOffice Calc", note: "Experienced" },
    ],
  },
  {
    key: "ai-emerging-tech",
    title: "AI & Emerging Tech",
    summary:
      "Hands-on with modern AI assistants for ideation, prototyping, and delivery.",
    items: [
      { name: "ChatGPT", note: "Experienced user" },
      { name: "Google AI Studio" },
      { name: "Qwen" },
      { name: "Manus" },
      { name: "Kimi" },
      { name: "Perplexity" },
      { name: "Claude" },
      { name: "cto.new" },
    ],
  },
  {
    key: "project-management-frameworks",
    title: "Project Management & Strategic Frameworks",
    summary:
      "Structured approaches that guide strategy, operations, and delivery.",
    items: [
      { name: "5W2H", note: "Experienced" },
      { name: "RACI Matrix", note: "Proficient" },
      { name: "SWOT Analysis", note: "Experienced" },
      { name: "BPM Canvas", note: "Familiar" },
      { name: "Ishikawa / Fishbone Diagram", note: "Familiar" },
      { name: "PDCA Cycle", note: "Experienced" },
      { name: "Kanban", note: "Experienced" },
      { name: "Gantt Chart", note: "Familiar" },
      { name: "Stakeholder Power-Interest Grid", note: "Experienced" },
      { name: "Logic Model / LogFrame", note: "Familiar" },
      { name: "SMART Objectives", note: "Experienced" },
      { name: "Process Mapping / Flowcharting", note: "Experienced" },
      { name: "Risk Matrix", note: "Familiar" },
      { name: "Value Stream Mapping", note: "Learning / Basic" },
      { name: "OKR", note: "Familiar" },
      { name: "Balanced Scorecard", note: "Familiar" },
      { name: "Mind Mapping", note: "Experienced" },
      { name: "Business Model Canvas", note: "Familiar" },
    ],
  },
];
